import { createFileRoute } from "@tanstack/react-router";
import { BackLink, PageHeading } from "@/ui";
import { SenderIdentityForm } from "#/components/settings/SenderIdentityForm";

// Integrations > Newsletter. The newsletter is the built-in integration, so its
// settings live under the page that lists it rather than as a sidebar row of
// their own (it was Blog > Newsletter until the email-as-integration change;
// `/newsletter` now redirects here).
//
// Sender identity: `senderName`, the From local-part and the mailing address
// every bulk send is required to carry — read by the broadcast send path, and the
// mailing address also by the consent email's footer (#853).
export const Route = createFileRoute("/dashboard/w/$workspaceId/integrations/newsletter")({
  component: NewsletterPage,
});

function NewsletterPage() {
  const { workspaceId } = Route.useParams();

  return (
    <section className="flex max-w-3xl flex-col gap-6">
      <BackLink to="/dashboard/w/$workspaceId/integrations" params={{ workspaceId }}>
        Integrations
      </BackLink>
      <PageHeading
        title="Newsletter"
        lede="Who your newsletter comes from: the name on the message, the address it is sent from, and the mailing address every send carries."
      />

      <SenderIdentityForm workspaceId={workspaceId} />
    </section>
  );
}
